module.exports = __webpack_public_path__ + "img/analyzing-photo-desktop-en.a2f58163.jpg";